const notifications = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return {
        ...state,
        [action.ts]: action.value,
      };
    case 'REMOVE_NOTIFICATION':
      const removed = { ...state };
      if (action.key in removed) {
        delete removed[action.key];
      }
      return removed;
    case 'REMOVE_ALL_NOTIFICATIONS':
      return {};
    default:
      return state;
  }
};

export default notifications;
